import { TS_AddonTrip } from '../TravelSeller/Models/TS_AddonTrip';
import { BookingItemInterface } from './BookingItemInterface';

export class AddonTrip extends TS_AddonTrip implements BookingItemInterface {
}